import React, { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import PostAddIcon from "@mui/icons-material/PostAdd";
import PostList from "../components/PostList";
import GroundingJourneyDialog from "../components/grounding/GroundingJourneyDialog";
import { getGroundingPosts } from "../utils/apiClient";
import useDocumentTitle from "../hooks/useDocumentTitle";

function GroundingJournal() {
  useDocumentTitle("Refleksion-journal");
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [createOpen, setCreateOpen] = useState(false);

  const loadPosts = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const data = await getGroundingPosts();
      setPosts(Array.isArray(data) ? data : []);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : err.message || "Kunne ikke indlæse indlæg");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadPosts();
  }, [loadPosts]);

  return (
    <Box sx={{ position: "relative", py: { xs: 1, sm: 2 } }}>
      <Typography variant="h5" sx={{ fontWeight: 700, letterSpacing: "-0.02em", mb: 2 }}>
        Refleksion-journal
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress size={28} />
        </Box>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <PostList posts={posts} emptyMessage="Ingen refleksion-journal-indlæg endnu." />
      )}

      <Fab
        color="primary"
        aria-label="Tilføj refleksion-journal"
        onClick={() => setCreateOpen(true)}
        sx={{
          position: "fixed",
          right: { xs: 16, sm: 24 },
          bottom: { xs: 16, sm: 24 },
        }}
      >
        <PostAddIcon />
      </Fab>

      <GroundingJourneyDialog
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onCreated={loadPosts}
      />
    </Box>
  );
}

export default GroundingJournal;
